import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { FAQS } from '../../data/woodworking';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section id="faq" className="bg-ivory py-14 text-ink sm:py-20" aria-labelledby="faq-title" data-id="element-169" data-mp="zrymszdn0cqb">
      <div className="mx-auto grid w-full max-w-6xl gap-6 px-5 sm:px-8 lg:grid-cols-12 lg:gap-14" data-id="element-170" data-mp="usvtgc70ruy6">
        <div className="lg:col-span-4" data-id="element-171" data-mp="73azky9bvda4">
          <h2 id="faq-title" className="text-balance font-brand text-[1.8rem] font-bold leading-[1.18] tracking-[-0.01em] text-ink sm:text-[2.3rem]" data-id="element-172" data-mp="22n7e99d4qeb">
            Questions before you start?
          </h2>
        </div>

        <ul className="divide-y divide-ivory-line border-y border-ivory-line lg:col-span-8" data-id="element-173" data-mp="c2e48hlebhhk">
          {FAQS.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.question} data-id="element-174" data-mp="1nhknxsdkl20y" data-mpi={index}>
                <h3 data-id="element-175" data-mp="hu8vey7k2mi8">
                  <button type="button" id={`faq-trigger-${index}`} onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex min-h-[64px] w-full items-center justify-between gap-4 py-4 text-left focus:outline-none focus-visible:ring-4 focus-visible:ring-forest/30" data-id="element-176" data-mp="hso37f8prfnj">
                    <span className="text-[1.02rem] font-semibold leading-snug text-ink sm:text-[1.08rem]" data-id="element-177" data-mp="422pe4y49vwi">
                      {faq.question}
                    </span>
                    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${isOpen ? 'border-forest bg-forest text-ivory' : 'border-ink/20 text-ink'}`} aria-hidden data-id="element-178" data-mp="8235du0v6f5o">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-179" data-mp="no7jjtebk358" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-180" data-mp="xgvesjpnhz1u">
                  {isOpen && <motion.div id={`faq-panel-${index}`} role="region" aria-labelledby={`faq-trigger-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-181" data-mp="sgr5bdn5u4l4">
                      <p className="max-w-2xl pb-5 pr-12 text-[0.98rem] leading-relaxed text-stone" data-id="element-182" data-mp="1p8b9l11d2s35">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}